import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'
import MessageContent from './MessageContent'
export default class Post extends Component {

  
    render() {

        let id = this.props.match.params.id;
        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <MessageContent id={id} />
                <Footer />

            </div>


        )
    }
}
